import { Component } from '@angular/core';
import { Store } from '@ngxs/store';
import { ISmallBrickComponent } from 'src/app/components/dashboard/brick-settings/brick-specific-type-settings/ISpecificBrickSettingsComponent';
import { ToolbarBrickBaseComponent } from './toolbar-brick.base.component';

@Component({
   selector: 'samweb-toolbar-brick-small',
   templateUrl: './toolbar-brick.small.component.html',
   styleUrls: ['./toolbar-brick.small.component.scss'],
})
export class ToolbarBrickSmallComponent extends ToolbarBrickBaseComponent implements ISmallBrickComponent {
   constructor(store: Store) {
      super(store);
   }
}
